import { gql } from "@apollo/client";

export const MUTATION_CREATE_BROKER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $amount: Int
    $debtor: String
    $paymentProfileAmount: Int
    $userLoadNumber: String
    $loadLength: Int
    $loadId: String
    $paymentProfilePaymentMethod: String
    $paymentProfileId: String
    $factoringAmount: Int
    $factoringFeeSplitRate: Int
    $payoutDays: String
    $lineItems: [LineItemInput]
    $contractType: String
    $carrierProNumber: String
    $purchaseOrderNumber: String
  ) {
    createOrUpdateBrokerFundingRequest(
      input: {
        amount: $amount
        debtor: $debtor
        paymentProfileAmount: $paymentProfileAmount
        userLoadNumber: $userLoadNumber
        loadLength: $loadLength
        loadId: $loadId
        paymentProfilePaymentMethod: $paymentProfilePaymentMethod
        paymentProfileId: $paymentProfileId
        factoringAmount: $factoringAmount
        factoringFeeSplitRate: $factoringFeeSplitRate
        payoutDays: $payoutDays
        lineItems: $lineItems
        contractType: $contractType
        carrierProNumber: $carrierProNumber
        purchaseOrderNumber: $purchaseOrderNumber
      }
    ) {
      fundingRequest {
        id
        warnings
      }
    }
  }
`;

export const MUTATION_CREATE_DIRECT_BROKER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $amount: Int
    $debtor: String
    $paymentProfileAmount: Int
    $userLoadNumber: String
    $loadLength: Int
    $paymentProfilePaymentMethod: String
    $paymentProfileId: String
    $factoringAmount: Int
    $factoringFeeSplitRate: Int
    $payoutDays: String
    $lineItems: [LineItemInput]
    $contractType: String
    $carrierProNumber: String
    $purchaseOrderNumber: String
    $originLocations: [LoadLocationInputType]
    $destinationLocations: [LoadLocationInputType]
    $noLoad: Boolean
  ) {
    createOrUpdateBrokerFundingRequest(
      input: {
        amount: $amount
        debtor: $debtor
        paymentProfileAmount: $paymentProfileAmount
        userLoadNumber: $userLoadNumber
        loadLength: $loadLength
        paymentProfilePaymentMethod: $paymentProfilePaymentMethod
        paymentProfileId: $paymentProfileId
        factoringAmount: $factoringAmount
        factoringFeeSplitRate: $factoringFeeSplitRate
        payoutDays: $payoutDays
        lineItems: $lineItems
        contractType: $contractType
        carrierProNumber: $carrierProNumber
        purchaseOrderNumber: $purchaseOrderNumber
        originLocations: $originLocations
        destinationLocations: $destinationLocations
        noLoad: $noLoad
      }
    ) {
      fundingRequest {
        id
        warnings
      }
    }
  }
`;

export const MUTATION_UPDATE_BROKER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $id: String
    $amount: Int
    $applyReserveHoldback: Boolean
    $debtor: String
    $paymentProfileAmount: Int
    $userLoadNumber: String
    $loadLength: Int
    $paymentProfilePaymentMethod: String
    $paymentProfileId: String
    $factoringFeeSplitRate: Int
    $payoutDays: String
    $lineItems: [LineItemInput]
    $contractType: String
    $carrierProNumber: String
    $purchaseOrderNumber: String
    $status: String
    $originLocations: LoadLocationInputType
    $destinationLocations: LoadLocationInputType
    $statusNote: String
    $userNotes: String
    $userReferenceNumber: String
    $carrierInvoiceNotes: String
    $debtorInvoiceNotes: String
    $attachments: [AttachmentInputType]
  ) {
    createOrUpdateBrokerFundingRequest(
      input: {
        id: $id
        applyReserveHoldback: $applyReserveHoldback
        amount: $amount
        debtor: $debtor
        paymentProfileAmount: $paymentProfileAmount
        userLoadNumber: $userLoadNumber
        loadLength: $loadLength
        paymentProfilePaymentMethod: $paymentProfilePaymentMethod
        paymentProfileId: $paymentProfileId
        factoringFeeSplitRate: $factoringFeeSplitRate
        payoutDays: $payoutDays
        lineItems: $lineItems
        contractType: $contractType
        carrierProNumber: $carrierProNumber
        purchaseOrderNumber: $purchaseOrderNumber
        status: $status
        firstOriginLocation: $originLocations
        finalDestinationLocation: $destinationLocations
        files: $attachments
        statusNote: $statusNote
        userNotes: $userNotes
        userReferenceNumber: $userReferenceNumber
        carrierInvoiceNotes: $carrierInvoiceNotes
        debtorInvoiceNotes: $debtorInvoiceNotes
      }
    ) {
      fundingRequest {
        created
        modified
        id
        warnings
        amount
        billToAddress
        billToCompanyEmail
        billToCompanyPhone
        firstOriginLocation
        finalDestinationLocation
        loadLength
        loadTrailerType
        fundedAt
        userReferenceNumber
        userNotes
        invoiceNumber
        discountRate
        fuelAdvanceRate
        fuelAdvanceFee
        fuelAdvanceAmount
        invoiceNotes
        carrierInvoiceNotes
        debtorInvoiceNotes
        invoiceSent
        invoiceSentCount
        lastInvoiceSentTime
        selfFinanceRequested
        contractType
        contractVersion
        source
        status
        statusNote
        userLoadNumber
        purchaseOrderNumber
        factored
        nonFactoredType
        chargeNonFactoredFee
        MinimumFee
        paymentMethod
        fuelAdvancePaymentMethod
        amountFunded
        attachments {
          id
          filename
          downloadUrl
          category
          visibleTo
        }
        paymentStatus
        paymentProfileAmount
        paymentProfilePaymentMethod
        paymentProfileDiscountRate
        paymentProfileFundedAt
        factoringAmountOffset
        factoringAmount
        factoringFeeSplitRate
        fuelAdvanceFeeSplitRate
        reserveHoldbackRate
        carrierProNumber
        reserveHoldback
        selectedFeeSplit
        passDebtorRateToCarrier
        applyReserveHoldback
        payoutDays
        invoiceDate
        frType
        clientInvoiceNumber
        factoring {
          id
          companyProfile
          ownerProfile
          factoringApproved
          discountRate
          marginDiscountRate
          attachments
          noaAttachments
          MinimumFee
          brokerApproved
          fuelAdvance
          fuelAdvanceRate
          fuelAdvanceFee
          fuelAdvanceLimit
          enableDiscount
          showDebtorDeclined
          createNonFactoredFr
          reserveHoldback
          reserveHoldbackRate
          nonFactoredFee
          allowNegativeMargin
          negativeMarginValue
          negativeMarginLimit
          enableReserveHoldbackHybrid
          defaultEnableReserveHoldback
          sendRateConfirmationRemoteApproved
          allowSelfFinanceFr
          stripeEnabled
          selfFinanceFrLimit
          selfFinanceRolling30DayFrLimit
          selfFinanceApprovalWithoutNoa
          companySettings
          enabledContractTypes
        }
        debtor {
          coBrokerAllowed
          created
          modified
          id
          email
          noaContactEmail
          paymentStatusEmail
          name
          companyName
          address
          phoneNumber
          faxNumber
          mc
          dot
          taxId
          avgpay
          creditApproved
          creditApprovedNote
          creditLimit
          originalsRequired
          dtpAllowance
          discountRate
          dunsNumber
        }
        paymentProfile {
          id
          created
          modified
          status
          authority
          companyName
          companyPhoneNumber
          ownerEmail
          companyMc
          paymentMethod {
            method
            accountNumberRedacted
          }
          brokerPaymentProfileRelation {
            coBrokeringApproval
            payoutDays
            factoringFeeSplitRate
            factoringCompanyRelation {
              id
              factoringCompany {
                id
                name
              }
            }
          }
        }
        factoringCompany {
          id
          created
          modified
          name
          email
          contactName
          contactEmail
          streetOne
          streetTwo
          city
          state
          zipCode
          phoneNumber
          status
          uploaded
          deleted
          account {
            method
            accountNumberRedacted
          }
        }
        load {
          id
        }
        factoringDebtorRelation {
          id
          noaSent
          noaPlaced
          noaActive
          noaRequested
          creditApproved
        }
        brokerMarginStatus
        carrierPaymentStatus
        frLineItems {
          id
          created
          category
          description
          amount
        }
        paymentProfileAccount {
          id
          accountNumberRedacted
          method
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_BROKER_FUNDING_REQUEST_TYPE = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $id: String
    $contractType: String
    $selfFinanceRequested: Boolean
  ) {
    createOrUpdateBrokerFundingRequest(
      input: { id: $id, contractType: $contractType, selfFinanceRequested: $selfFinanceRequested }
    ) {
      fundingRequest {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_BROKER_FUNDING_REQUEST_STATUS = gql`
  mutation CreateOrUpdateBrokerFundingRequest($id: String, $status: String) {
    createOrUpdateBrokerFundingRequest(input: { id: $id, status: $status }) {
      fundingRequest {
        id
      }
    }
  }
`;
